// extracted by mini-css-extract-plugin
module.exports = {"main-component":"budget_main-component__2h8cj"};